import { authGetJWT, reportVpressRegister } from '@/api'
import { ProductStatus } from '@/enums'
import { useAuthStore } from '@/pinia/auth'
import { useStyleStore } from '@/pinia/style'
import { defineStore } from 'pinia'

export const useKnowledgeBaseStore = defineStore('knowledgeBase', {
  persist: true,
  state: () => ({
    hiddenArticlesIDs: []
  }),
  actions: {
    addHiddenArticlesIDs(Id) {
      this.hiddenArticlesIDs.push(Id)
    },
    removeHiddenArticlesIDs(Id) {
      const index = this.hiddenArticlesIDs.indexOf(Id)
      this.hiddenArticlesIDs.splice(index, 1)
    },
    async generateLinkWeb2Print({ store_url, api_url }) {
      const parsedUrl = process.env.NODE_ENV === 'development' ? new URL(api_url) : new URL(window.location)
      const prefix = parsedUrl.hostname.split('.')[0]
      const token = (await authGetJWT())?.token
      const { url } = await reportVpressRegister({
        jwt_token: token,
        prefix,
        store_url
      })
      const response = window.open(url, '_blank')
      if (!response) {
        window.location.href = url
      }
    }
  },
  getters: {
    articles() {
      return [
        {
          duration: undefined,
          id: '0',
          imageURL: 'Portal Setup Checklist.png',
          url: 'portal/how-to-set-up'
        },
        {
          duration: undefined,
          id: '1',
          imageURL: 'How to Buy Branded Mode.png',
          url: 'branded-mode/how-to-purchase'
        },
        {
          duration: undefined,
          id: '2',
          imageURL: 'Branded Mode Setup Guide.png',
          url: 'branded-mode/how-to-set-up'
        },
        {
          duration: undefined,
          id: '3',
          imageURL: 'Deploying Branded Mode.png',
          url: 'branded-mode/deployment'
        },
        {
          duration: undefined,
          id: '4',
          imageURL: 'Increase Sales with Branded Mode.png',
          url: 'branded-mode/benefits'
        }
      ]
    },
    filteredArticles(state) {
      const authStore = useAuthStore()
      const styleStore = useStyleStore()
      const filter = (article) => {
        if (state.hiddenArticlesIDs.includes(article.id)) return false
        else if (authStore.isExtruderOrExpress && article.id === '1') return false
        else if (styleStore.fabricator?.accountProductStatus === ProductStatus.LEAD_GEN_ONLY && article.id === '0')
          return false
        return true
      }
      return state.articles.filter(filter)
    }
  }
})
